/* markup builders: future Liquid */

  /* the landing carries its own copy in markup; every other page is handed this
     one, and wireMenu adds the mark's handles and glosses */
  function menuOverlayHTML() {
    const brand = asset('shared/assets/brand/');
    return '<div class="menu-overlay" id="menu-overlay" role="dialog" aria-modal="true"' +
      ' aria-label="menu" hidden>' +
      '<img class="menu-smoke" src="' + brand + 'menu-wash.jpg" alt="" loading="lazy" decoding="async">' +
      '<button class="menu-close u" id="menu-close" type="button">CLOSE</button>' +
      '<div class="menu-mark" id="menu-mark">' +
      '<img class="menu-logo logo-arc" src="' + brand + 'logo-paper.png" alt="Turiya mark" loading="lazy" decoding="async">' +
      '<img class="menu-logo logo-dot" src="' + brand + 'logo-paper.png" alt="" loading="lazy" decoding="async">' +
      '</div>' +
      '<p class="menu-foot u">TURIYA · SEOUL</p>' +
      '</div>';
  }

  /* one pair of lines for the whole site (settings.half_*_line): the menu and
     the drawer said this in two different sentences until they read one source */
  const MN_LINE = {
    collective: setting('half_collective_line', 'artists, and their work'),
    selective: setting('half_selective_line', 'designers, and their work')
  };
  function glossHTML(key) {
    const href = key === 'collective' ? ROUTES.posts : ROUTES.products;
    return '<p class="mn-gloss mn-gloss-' + key + '">' +
      '<a class="mn-key u" href="' + href + '">' + key + '</a>' +
      '<span class="mn-val u">' + MN_LINE[key] + '</span>' +
      '</p>';
  }

/* wiring: ports as-is */

  /* ---------- menu: smoke unfurls, then the mark ---------- */
  function wireMenu() {
    let mo = document.getElementById('menu-overlay');
    /* a page that asks for the door but does not carry it gets the shared one; the
       button is the ask, so a page with neither stays as it was */
    if (!mo && document.getElementById('menu-btn')) {
      document.body.insertAdjacentHTML('afterbegin', menuOverlayHTML());
      mo = document.getElementById('menu-overlay');
    }
    if (!mo) return;
    /* the glosses arrive with the reveal rather than waiting for the hand */
    document.body.dataset.mnote = 'stand';
    const btn = document.getElementById('menu-btn');
    const close = document.getElementById('menu-close');
    const smoke = mo.querySelector('.menu-smoke');
    const mark = document.getElementById('menu-mark');
    const arc = mo.querySelector('.logo-arc');
    const dot = mo.querySelector('.logo-dot');
    const foot = mo.querySelector('.menu-foot');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let tl = null, drift = null, settle = null, lastFocus = null;

    mark.insertAdjacentHTML('beforeend',
      '<span class="mn-hit mn-hit-dot" aria-label="collective"></span>' +
      '<span class="mn-hit mn-hit-arc" aria-label="selective"></span>' +
      glossHTML('collective') +
      glossHTML('selective'));
    wireMarkTumble(mark, 'tumble4', 'mn');
    wireGlossLatch(mark, 'mn');
    /* a clean click goes through; the tumble's suppressor has already cancelled
       clicks that were drags or catches */
    [['dot', ROUTES.posts], ['arc', ROUTES.products]].forEach(function (pair) {
      const hit = mark.querySelector('.mn-hit-' + pair[0]);
      hit.addEventListener('click', function (e) {
        if (e.defaultPrevented) return;
        location.href = pair[1];
      });
    });

    function reveal(instant) {
      mo.classList.remove('ready');
      if (instant) {
        mo.classList.add('lit');
        [smoke, foot].forEach(function (el) { el.style.opacity = 1; });
        mo.classList.add('named');
        mo.classList.add('ready');
        return;
      }
      if (tl) tl.pause();
      requestAnimationFrame(function () { mo.classList.add('lit'); });
      tl = anime.timeline({
        easing: 'cubicBezier(.22,.61,.36,1)',
        complete: function () {
          mo.classList.add('ready');
          /* the arrival's inline opacity stands down, so the ready stylesheet can
             quiet a half under the hand the way the plate does */
          arc.style.opacity = ''; dot.style.opacity = '';
        }
      });
      tl.add({ targets: smoke, opacity: [0, 1], scale: [1.3, 1], duration: 1500 })
        /* the words come up with the mark, not after the pour: waiting on the
           halves opened the door on two unnamed shapes for a whole first look */
        .add({ targets: [arc, dot], opacity: [0, 1], scale: [0.94, 1], duration: 1100,
               begin: function () { mo.classList.add('named'); } }, 600);
      tl.add({ targets: foot, opacity: [0, 1], duration: 600 }, 1450);

      if (drift) drift.pause();
      drift = anime({
        targets: smoke, scale: [1, 1.08], duration: 22000,
        easing: 'linear', direction: 'alternate', loop: true, delay: 1500
      });

      /* watchdog: if frames are throttled the reveal must still land */
      clearTimeout(settle);
      settle = setTimeout(function () {
        if (mo.classList.contains('ready') || mo.hidden) return;
        mo.classList.add('lit');
        [smoke, foot].forEach(function (el) { el.style.opacity = 1; });
        arc.style.opacity = ''; dot.style.opacity = '';
        mo.classList.add('named');
        mo.classList.add('ready');
      }, 3200);
    }

    function focusables() {
      return mo.querySelectorAll('a[href], button:not([disabled])');
    }

    function open(instant) {
      lastFocus = document.activeElement;
      mo.hidden = false;
      document.body.style.overflow = 'hidden';
      const bare = instant || reduce || typeof anime === 'undefined';
      reveal(bare);
      close.focus();
      /* the overlay marks the address, so a back from a page opened here returns
         to the open menu */
      history.replaceState(null, '', '#menu');
      mo.dispatchEvent(new CustomEvent('menu:open', { detail: { instant: bare } }));
    }

    function shut() {
      mo.dispatchEvent(new CustomEvent('menu:shut'));
      history.replaceState(null, '', location.pathname + location.search);
      document.body.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
      [arc, dot].forEach(function (el) { if (el.__markReset) el.__markReset(); });
      if (reduce || typeof anime === 'undefined') { mo.hidden = true; return; }
      if (tl) tl.pause();
      if (drift) drift.pause();
      /* the furniture leaves first; the pour's own exit (menu.seq.js) is longer */
      anime({
        targets: [smoke, arc, dot, foot],
        opacity: 0, duration: 360, easing: 'cubicBezier(.22,.61,.36,1)',
        complete: function () {
          const land = function () {
            mo.hidden = true;
            mo.classList.remove('ready');
            mo.classList.remove('named');
            mo.classList.remove('lit');
          };
          /* with the sequence armed the door stands open until the rewind lands */
          if (document.body.dataset.seq === '1') {
            mo.addEventListener('menu:shut-done', land, { once: true });
          } else {
            land();
          }
        }
      });
    }

    btn.addEventListener('click', function () { open(false); });
    close.addEventListener('click', shut);
    /* the empty ink is also the way out; a press that began on the mark is a
       gesture, not a leave-taking, wherever it ends */
    let downOnMark = false;
    mo.addEventListener('pointerdown', function (e) {
      downOnMark = !!(e.target.closest && e.target.closest('#menu-mark'));
    });
    mo.addEventListener('click', function (e) {
      if (downOnMark || e.defaultPrevented) return;
      if (e.target.closest && e.target.closest('#menu-mark, #menu-close, a')) return;
      shut();
    });
    /* arriving with #menu in the address: the menu is simply there, no reveal */
    if (location.hash === '#menu') open(true);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !mo.hidden) shut();
    });

    /* modal trap: Tab cycles inside the overlay while it is open */
    mo.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      const f = focusables();
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
